import { render, staticRenderFns } from "./PastSectionTeacher.vue?vue&type=template&id=bdfe5d74&scoped=true"
import script from "./PastSectionTeacher.vue?vue&type=script&lang=js"
export * from "./PastSectionTeacher.vue?vue&type=script&lang=js"
import style0 from "./PastSectionTeacher.vue?vue&type=style&index=0&id=bdfe5d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfe5d74",
  null
  
)

export default component.exports